import ApiService from "./ApiService"

export async function apiGetBOECount() {
    return ApiService.fetchData({
        url: '/notification/count',
        method: 'get'
    })
}

export async function apiGetBOEByID(id) {
    return ApiService.fetchData({
        url: '/api/Billofentry/' + id + "/",
        method: 'get'
    })
}
//apiGetCustomsBOEs
export async function apiGetCustomsBOEs() {
    return ApiService.fetchData({
        url: '/api/CustomDB/',
        method: 'get'
    })
}


export async function apiGetBOEs() {
    return ApiService.fetchData({
        url: '/api/BillofentryPOST/?ordering=-id',
        method: 'get'
    })
}

export async function apiGetBOEsItems() {
    return ApiService.fetchData({
        url: '/api/ItembillPOST/',
        method: 'get'
    })
}

export async function apiPostBOE(data) {
    return ApiService.fetchData({
        url: '/api/BillofentryPOST/',
        method: 'post',
        data
    })
}

export async function apiPutBOE(data) {

    return ApiService.fetchData({
        url: '/api/BillofentryPOST/' + data.get("id") + "/",
        method: 'put',
        data
    })
}

export async function apiDeleteBOE(data) {
    return ApiService.fetchData({
        url: '/api/Billofentry/' + data.id + "/",
        method: 'delete',
        data
    })
}

export async function apiDeleteBOEItem(data) {
    return ApiService.fetchData({
        url: '/api/ItembillPOST/' + data.id + "/",
        method: 'delete',
        data
    })
}

export async function apiPutBOEItem(data) {

    return ApiService.fetchData({
        url: '/api/ItembillPOST/' + data.get("id") + "/",
        method: 'put',
        data
    })
}

export async function apiPostBOEItem(data) {
    return ApiService.fetchData({
        url: '/api/ItembillPOST/',
        method: 'post',
        data
    })
}


// استبدل دالة الرفع كلها بهي:
export async function uploadItemBillsExcel({ boeId, file, dryRun = false, atomic = false }) {
  const fd = new FormData()
  fd.append('file', file)                 // الاسم لازم يكون 'file'
  fd.append('dry_run', dryRun ? 'true' : 'false')
  fd.append('atomic', atomic ? 'true' : 'false')

  // المهم: لا تضيف Content-Type، خليه للمتصفح
  const res = await ApiService.fetchData({
    url: `/api/Billofentry/${boeId}/upload-itembills/`,
    method: 'post',
    data: fd,
  })

  // بعض نسخ ApiService بترجع { data: ... }، فنوحّد الشكل:
  const body = res?.data ?? res

  // لو في حال رجع كنص JSON (بعض السيرفرات تعمل هيك)
  if (typeof body === 'string') {
    try { return JSON.parse(body) } catch { /* ignore */ }
  }
  return body
}

